import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=434a0b34&scoped=true&"
import script from "./Notification.vue?vue&type=script&lang=js&"
export * from "./Notification.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/notification.css?vue&type=style&index=0&id=434a0b34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434a0b34",
  null
  
)

export default component.exports